import { AppConstants } from "@constants/app-constants";
import { IWindow } from "src/models/iWindow";



export class DtmDigitalData {
    data = {
        page: {
            environment: ''
        },
        user: {
          cce: '',
          state: '',
          userid: ''
        },
        member: {
            searchType: ''
        },
    };


    constructor(private userCacheService: any, private window: IWindow) { }

    setPageData(): void {
    }

    setSessionData(userCache: any, environment: string): void {
        this.data.user.cce = userCache.userInformation.cceName || '';
        this.data.user.state = userCache.userInformation.state || '';
        this.data.user.userid = userCache.userInformation.userId || '';
        this.data.member.searchType = sessionStorage.getItem(AppConstants.SEARCH_TYPE) || '';
        this.data.page.environment = environment || '';
    }

}